<template>
    <div class="resetPassword">
        <van-form @submit="onSubmit">
            <van-field
                v-model="newPassword"
                type="password"
                name="新密码"
                label="新密码"
                placeholder="请输入新密码"
                :rules="[{ required: true, message: '请输入新密码' }]"
            />
            <van-field
                v-model="checkPassword"
                type="password"
                name="确认密码"
                label="确认密码"
                placeholder="请确认密码"
                :rules="[{ required: true, message: '请填写确认密码' }]"
            />
            <div style="margin: 16px">
                <van-button class="loginBtn" color="#206235" round block type="info" native-type="submit"
                    >提交</van-button
                >
            </div>
        </van-form>
    </div>
</template>

<script>
import { Field, Form, Button, Toast } from 'vant'

export default {
    props: {},
    components: {
        [Button.name]: Button,
        [Form.name]: Form,
        [Field.name]: Field,
        [Toast.name]: Toast
    },
    data() {
        return {
            newPassword: '',
            checkPassword: ''
        }
    },
    computed: {},
    watch: {},
    methods: {
        onSubmit() {
            if (this.newPassword === '123456') {
                Toast.fail('不可使用初始密码')
                return
            }
            if (this.newPassword !== this.checkPassword) {
                Toast.fail('两次密码不一致')
                return
            }

            let json = JSON.parse(localStorage.getItem('userInfo')).user
            json.password = this.newPassword
            this.$api.login.resetPwd(json).then((res) => {
                if (res.msg) {
                    return
                }
                Toast.success('修改成功')
                this.$router.go(-1)
            })
        }
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    activated() {},
    deactivated() {},
    beforeDestroy() {},
    destroyed() {}
}
</script>

<style lang="less" scoped>
.resetPassword {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 50px;

    .loginBtn {
        color: #fff !important;
        border-radius: 12px;
        width: 100%;
        padding: 12px;
    }
}
</style>
